<template>
  <v-container
               fill-height fluid>
    <v-row
        align="center"
        justify="center">
      <v-col
          xs="12" sm="7" md="3">
          <v-alert
          type="success"
          >{{$t('success.title')}}
          </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Success"
}
</script>

<style scoped>

</style>
